/* global axios */
import ApiClient from './ApiClient';

class CrmAPI extends ApiClient {
  constructor() {
    super('crm', { accountScoped: true });
  }

  conversation(id, params) {
    return axios.get(`${this.url}/conversations/${id}`, { params });
  }

  act(id, data) {
    return axios.patch(`${this.url}/conversations/${id}`, data);
  }

  board(params) {
    return axios.get(`${this.url}/board`, { params });
  }

  settings(id, columns, accessTeamIds) {
    return columns
      ? axios.patch(`${this.url}/settings/${id}`, {
          columns,
          access_team_ids: accessTeamIds,
        })
      : axios.get(`${this.url}/settings/${id}`);
  }

  actionOptions() {
    return axios.get(`${this.url}/action_options`);
  }

  permissions(data) {
    return data
      ? axios.patch(`${this.url}/permissions`, data)
      : axios.get(`${this.url}/permissions`);
  }
}
export default new CrmAPI();
